import OrderFooter from './OrderFooter'

export default function Cart({ cart, onAdd, onRemove, onClear, onOrder, total, showHeader = true, isOverlay = false, onBack, lastOrderTotal = null }) {
  // Read per-browser print settings from localStorage (new keys)
  // Fall back to legacy global key if no per-browser setting exists
  const printEnabled = JSON.parse(localStorage.getItem('printEnabled_browser') ?? localStorage.getItem('printEnabled_global') ?? 'false')
  
  const rightButtonLabel = printEnabled ? '🖨️ Drucken' : '✅ Fertig'
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: isOverlay ? '100%' : '100%',
      background: '#fff',
      position: isOverlay ? 'fixed' : 'relative',
      top: isOverlay ? 0 : 'auto',
      left: isOverlay ? 0 : 'auto',
      right: isOverlay ? 0 : 'auto',
      bottom: isOverlay ? 0 : 'auto',
      borderLeft: '2px solid #ddd',
    },
    header: {
      display: showHeader ? 'flex' : 'none',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '15px',
      background: '#1a1a2e',
      color: '#fff',
      fontSize: '18px',
      fontWeight: 'bold',
      position: 'relative',
    },
    headerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    lastOrder: {
      fontSize: '18px',
      fontWeight: 'normal',
      color: '#aaa',
    },
    items: {
      flex: 1,
      overflowY: 'auto',
      padding: '10px',
      paddingBottom: '80px',
    },
    item: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px',
      borderBottom: '1px solid #eee',
    },
    itemInfo: {
      flex: 1,
    },
    itemName: {
      fontSize: '14px',
      fontWeight: '500',
    },
    itemPrice: {
      fontSize: '12px',
      color: '#666',
    },
    controls: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    qtyButton: {
      width: '28px',
      height: '28px',
      border: 'none',
      borderRadius: '4px',
      background: '#4ecdc4',
      color: '#fff',
      cursor: 'pointer',
      fontSize: '16px',
    },
    deleteButton: {
      width: '28px',
      height: '28px',
      border: 'none',
      borderRadius: '4px',
      background: '#f44336',
      color: '#fff',
      cursor: 'pointer',
      fontSize: '16px',
    },
    qtyDisplay: {
      fontSize: '14px',
      fontWeight: 'bold',
      minWidth: '20px',
      textAlign: 'center',
    },
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <span>Bestellung</span>
          {lastOrderTotal !== null && (
            <span style={styles.lastOrder}>
              Letzte: {lastOrderTotal.toFixed(2)}€
            </span>
          )}
        </div>
        {onBack && (
          <button 
            onClick={onBack}
            style={{ position: 'absolute', left: '10px', background: 'transparent', border: 'none', color: '#fff', fontSize: '16px', cursor: 'pointer' }}
          >
            ←
          </button>
        )}
      </div>
      <div style={styles.items}>
        {Object.values(cart).map((item) => (
          <div key={item.id} style={styles.item}>
            <div style={styles.itemInfo}>
              <div style={styles.itemName}>{item.name}</div>
              <div style={styles.itemPrice}>
                {((item.preis || 0) + (item.pfand || 0)).toFixed(2)}€ × {item.menge}
              </div>
            </div>
            <div style={styles.controls}>
              {item.menge === 1 ? (
                <button
                  style={styles.deleteButton}
                  onClick={() => onRemove(item.id)}
                  title="Entfernen"
                >
                  🗑️
                </button>
              ) : (
                <button
                  style={styles.qtyButton}
                  onClick={() => onRemove(item.id)}
                >
                  -
                </button>
              )}
              <span style={styles.qtyDisplay}>{item.menge}</span>
              <button
                style={styles.qtyButton}
                onClick={() => onAdd(item)}
              >
                +
              </button>
            </div>
          </div>
        ))}
        {Object.keys(cart).length === 0 && (
          <div style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
            Leere Bestellung
          </div>
        )}
      </div>
      <OrderFooter
        total={total}
        style={{ position: isOverlay ? 'fixed' : 'sticky', bottom: 0, left: isOverlay ? 0 : 'auto', right: isOverlay ? 0 : 'auto' }}
        leftButton={{
          label: '🗑️ Leeren',
          onClick: onClear,
          color: '#f44336'
        }}
        rightButton={{
          label: rightButtonLabel,
          onClick: onOrder,
          color: '#4ecdc4'
        }}
      />
    </div>
  )
}